import { ReactComponent as SvgSnowflake } from 'public/assets/icons/snowflakeFlat.svg';
import { ResortPhotosData } from 'components/widget/types';
import { ImageComponent } from 'components/common/ImageComponent';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { SectionHeader } from '../SectionHeader';
import styles from './styles.module.scss';

interface Props {
  paragraphs?:
  | {
    dangerouslySetInnerHTML: {
      __html: string;
    };
  }
  | {
    dangerouslySetInnerHTML: {
      __html: string;
    };
  };
  photos?: ResortPhotosData;
}

export const InsideScoopSection = ({ paragraphs, photos }: Props) => {
  const { t } = useOTSTranslation('common');
  return (
    <section id={styles.insideScoop}>
      <SectionHeader title={t('resort.overview.insideScoopTab')} />

      {photos && photos[0] && (
        <div>
          <div>
            <ImageComponent alt={photos[0].name} src={photos[0].cdnUrl} />
          </div>

          <div>
            <SvgSnowflake width="100%" height="100%" viewBox="0 0 176 193" />
          </div>
        </div>
      )}

      <SectionHeader description={paragraphs} />
    </section>
  );
};
